import React, { SVGProps } from 'react'
const SvgTransactionPushPending = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#697080'}
      fillRule="evenodd"
      d="M6 3h8.03c.53 0 .97.45.97 1v2.76c0 .13-.05.25-.14.35l-2.41 2.51c-.19.19-.19.49-.01.69l.19.21h-1.34a.985.985 0 0 1 .12-1.23l2.45-2.58c.09-.1.14-.22.14-.35V4.5c0-.28-.22-.5-.5-.5h-7c-.28 0-.5.22-.5.5v1.86c0 .12.05.25.14.34L8.6 9.29c.36.38.36.98.01 1.36l-2.48 2.71c-.08.09-.13.21-.13.34v1.8c0 .28.22.5.5.5h2.79v1H6c-.55 0-1-.45-1-1v-2.7c0-.12.05-.24.13-.34l2.43-2.64c.18-.19.18-.49 0-.68L5.14 7.11A.518.518 0 0 1 5 6.76V4c0-.55.45-1 1-1Zm6.5 2.38v.8l.01.01c0 .22-.1.43-.27.57L10.5 8.22c-.29.26-.72.26-1.01 0L7.77 6.76a.741.741 0 0 1-.27-.57v-.81c0-.21.2-.38.45-.38h4.1c.25 0 .45.17.45.38Zm3.24 5.303a.148.148 0 0 1 .03-.003h.01a.468.468 0 0 1 .46.441v.004l.05 1.4V12.56c0 .248-.19.455-.441.47h-.004l-1.38.05h-.005a.467.467 0 0 1-.46-.44v-.01a.47.47 0 0 1 .442-.48h.003l.065-.002a2.695 2.695 0 0 0-2.898.512 2.909 2.909 0 0 0-.826 2.786.464.464 0 0 1-.33.56.149.149 0 0 1-.036.004H10.34a.46.46 0 0 1-.446-.357c-.312-1.34.103-2.755 1.104-3.683a3.562 3.562 0 0 1 2.64-.97c.61.036 1.189.218 1.703.534l-.01-.37-.001-.004c0-.23.158-.447.41-.477Zm1.325 3.29a.46.46 0 0 0-.56-.339.463.463 0 0 0-.341.56 2.909 2.909 0 0 1-.827 2.786v.001a2.664 2.664 0 0 1-1.837.729c-.404 0-.808-.092-1.178-.273l.19-.017a.457.457 0 0 0 .417-.507.463.463 0 0 0-.505-.422l-1.366.13a.457.457 0 0 0-.417.504l.12 1.408v.006a.472.472 0 0 0 .459.421H11.25l.019-.001a.462.462 0 0 0 .4-.503l-.025-.322c.504.3 1.075.47 1.667.506H13.5c.918 0 1.785-.345 2.462-.98 1-.928 1.416-2.344 1.104-3.684v-.002Z"
      clipRule="evenodd"
      style={{
        fill: 'color(display-p3 .4118 .4392 .502)',
        fillOpacity: 1,
      }}
    />
  </svg>
)
export default SvgTransactionPushPending
